import { Component } from '@angular/core';
import { AngularCoreIoCKeys, IAngularCoreIoCContainer } from 'angular-core-src';
import { IoCContainer, IWebCoreSettings } from '@lmnop/web-core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseComponent } from '../base/base-component.component';

@Component({
    template: '',
    selector: 'angular-core-page-base',
})
export abstract class PageBase extends BaseComponent {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.ioc = IoCContainer.get(AngularCoreIoCKeys.IAngularCoreIoCContainer);
        this.settings = this.ioc.settings;
    }

    protected ioc: IAngularCoreIoCContainer;
    protected settings: IWebCoreSettings;
}
